import { render, staticRenderFns } from "./LawCollectionEntityDetails.vue?vue&type=template&id=0a18a58f&scoped=true"
import script from "./LawCollectionEntityDetails.vue?vue&type=script&lang=js"
export * from "./LawCollectionEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./LawCollectionEntityDetails.vue?vue&type=style&index=0&id=0a18a58f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a18a58f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a18a58f')) {
      api.createRecord('0a18a58f', component.options)
    } else {
      api.reload('0a18a58f', component.options)
    }
    module.hot.accept("./LawCollectionEntityDetails.vue?vue&type=template&id=0a18a58f&scoped=true", function () {
      api.rerender('0a18a58f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LawCollectionEntityDetails.vue"
export default component.exports